export var FSMStages = /*#__PURE__*/function (FSMStages) {
  FSMStages["IDLE"] = "idle";
  FSMStages["LOAD_DATA"] = "load_data";
  FSMStages["CONNECTING"] = "connecting";
  FSMStages["ACTIVE"] = "active";
  FSMStages["RECONNECT"] = "reconnect";
  FSMStages["CAPTCHA_NEEDED"] = "captcha_needed";
  FSMStages["BLOCKED"] = "blocked";
  FSMStages["ERROR"] = "error";
  return FSMStages;
}({});